<template>
  <div>
    <div>
      <grid
        :entityTypeId="entityTypeId"
        :formId="formId"
        :entityTypeName="entityTypeName"
        :primaryEntity="primaryentity"
        :showFormOnEmpty="true"
        :showContinueButton="true"
        @continueButton="$emit('continueButton')"
        @dirty="$emit('dirty', $event)"
        :basePageSize="gridPageSize"
        :baseCurrentPage="gridCurrentPage"
        @setPageSize="setPageSize"
        @setCurrentPage="setCurrentPage"
      >
      </grid>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProfileCommunityService',
  data() {
    return {
      entityTypeId: 5,
      formId: 3,
      entityTypeName: 'Community Service',
      gridPageSize: 5,
      gridCurrentPage: 1
    };
  },
  props: {
    primaryentity: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    setPageSize(size) {
      this.gridPageSize = parseInt(size);
    },
    setCurrentPage(page) {
      this.gridCurrentPage = parseInt(page);
    }   
  }
};
</script>
